import React from "react"; // @TODO try to avoid api into dumb components

import useApi from "../../../api";
import Package from "../../Package";
import "./LotNavigation.scss";
export var LotNavigation = function LotNavigation(a) {
  var b = a.release,
      c = a.lot,
      d = a.assetPath,
      e = useApi();
  return /*#__PURE__*/React.createElement("div", {
    className: "lfs--lot"
  }, /*#__PURE__*/React.createElement(Package, {
    key: c.slug,
    package: c,
    releaseFlyer: d + b.flyer,
    isLot: !0
  }), c.packages && c.packages.length ? /*#__PURE__*/React.createElement("div", {
    className: "ta-row"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "available"
  }, "Available Packages"), c.packages.map(function (a, b) {
    var c = a.slug,
        d = e.packages.retrieve(c);
    return d ? /*#__PURE__*/React.createElement("span", {
      key: "lot-nav-".concat(b)
    }, /*#__PURE__*/React.createElement(Package, {
      key: d.slug,
      package: d,
      isSummary: !0,
      showNameAsLotName: !0
    })) : null;
  })) : null);
};
export default LotNavigation;